import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Row, Col, Badge, Card, Space, Button, message, Skeleton } from "antd";
import { connect } from "react-redux";

import {
  ActivationDetails,
  GeneralInformation,
  RoleDetails,
  HotelDetails,
} from "../../components/Users/UserDetails";
import { CardElement } from "../../components/Common/UIElements";
import {
  useGetSingleUser,
  useGetUserInvitations,
  useAddUserInvitation,
  useUpdateUserStatus,
  useGetEnvelopSignerHotels,
} from "../../hooks/user.hooks";
import { useRemoveFromEnvelopSigners } from "../../hooks/signature.hooks";

const cardTitleStyle = {
  fontWeight: "bold",
};

const getStatusColor = (status) => {
  switch (status) {
    case "Active":
      return "#52c41a";
    case "Pending":
      return "#ffbc41";
    case "Created":
      return "#3b6cb4";
    default:
      return "#697177";
  }
};

const UserDetail = (props) => {
  const { user_id } = useParams();

  const [userId, setUserId] = useState();

  useEffect(() => {
    setUserId(user_id);
  }, [user_id]);

  const hasEditAccess = !(
    props.api?.permission?.sm_user_managment &&
    props.api?.smData?.data?._id === userId
  );

  const {
    data: userData,
    isLoading: isUserDataLoading,
    refetch: refetchUserData,
  } = useGetSingleUser(userId, {
    onError: (error) => message.error(error.response.data.message),
  });

  const {
    data: userInvitationData,
    isLoading: isUserInvitationDataLoading,
    refetch: refetchUserInvitations,
  } = useGetUserInvitations(userId, {
    onError: (error) => message.error(error.response.data.message),
  });

  const { data: userSignerStatus, refetch: refetchEnvelopeSignerHotels } =
    useGetEnvelopSignerHotels({ id: userId });

  const { mutate: updateStatus } = useUpdateUserStatus({
    onError: (error) => message.error(error.response.data.message),
    onSuccess: () => {
      refetchUserData();
      refetchUserInvitations();
      refetchEnvelopeSignerHotels();
    },
  });

  const { mutate: removeSigners } = useRemoveFromEnvelopSigners();

  const { mutate: addInvitation, isLoading: isAddingInvitation } =
    useAddUserInvitation({
      onError: (error) => message.error(error.response.data.message),
      onSuccess: (data) => {
        message.success(data.message);
        refetchUserData();
        refetchUserInvitations();
      },
    });

  return (
    // <div className="containerTitleStyles">
    //   <div className="container_ab">
    //     <h2 className="titleStyles">User Details</h2>
        <CardElement title="User Details">
        {/* <Card style={cardSstyle}> */}
          <Row gutter={{ xs: 16, sm: 16, md: 24, lg: 32 }}>
            <Col
              className="gutter-row"
              span={4}
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
            >
              {isUserDataLoading || isUserInvitationDataLoading ? (
                <Skeleton
                  active
                  size="small"
                  paragraph={false}
                  title={{ width: "40%" }}
                />
              ) : (
                <Space size={50}>
                  <h2>{userData?.user_name}</h2>
                  <Badge
                    count={userInvitationData?.userStatus}
                    style={{
                      backgroundColor: getStatusColor(
                        userInvitationData?.userStatus,
                      ),
                    }}
                  />
                </Space>
              )}
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={8}>
              <p>User Name</p>
            </Col>
          </Row>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
              <GeneralInformation
                userDetails={userData}
                hasEditAccess={hasEditAccess}
                cardTitleStyle={cardTitleStyle}
                isLoading={isUserDataLoading}
              />
            </Col>
            <Col xs={24} sm={24} md={16} lg={16} xl={16}>
              <HotelDetails
                userDetails={userData}
                cardTitleStyle={cardTitleStyle}
                hasEditAccess={hasEditAccess}
                isLoading={isUserDataLoading}
              />
            </Col>
          </Row>
          <br />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col
              className="gutter-row"
              span={8}
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
            >
              <RoleDetails
                userDetails={userData}
                hasEditAccess={hasEditAccess}
                cardTitleStyle={cardTitleStyle}
                isLoading={isUserDataLoading}
              />
            </Col>
            <Col
              className="gutter-row"
              span={16}
              xs={24}
              sm={24}
              md={16}
              lg={16}
              xl={16}
            >
              <Row>
                <Col xs={20} sm={20} md={20} lg={24} xl={24}>
                  <ActivationDetails
                    tableData={userInvitationData?.invitationData ?? null}
                    cardTitleStyle={cardTitleStyle}
                    userDetails={userData}
                    userStatus={userInvitationData?.userStatus}
                    userSignerStatus={userSignerStatus}
                    updateStatus={updateStatus}
                    removeSigners={removeSigners}
                    isLoading={isUserDataLoading || isUserInvitationDataLoading}
                    userId={userId}
                  />
                </Col>
              </Row>
              {process.env.REACT_APP_PLATFORM_TYPE &&
              process.env.REACT_APP_PLATFORM_TYPE === "GENERIC" ? (
                <Row style={{ height: "20px" }}>
                  <Button
                    type="primary"
                    onClick={() =>
                      addInvitation({
                        data: {
                          email: userData?.email,
                          password_reset: userData?.welcome_reset_status
                            ? true
                            : null,
                        },
                        id: userData?._id,
                      })}
                    shape="round"
                    style={{
                      position: "absolute",
                      bottom: "0",
                      right: "40px",
                    }}
                    loading={isAddingInvitation}
                    disabled={!userData?.email || userData?.status == false}
                  >
                    {userData?.welcome_reset_status
                      ? "Send Password Reset Link"
                      : "Send Invitation"}
                  </Button>
                </Row>
              ) : null}
            </Col>
          </Row>
        </CardElement>
  );
};

UserDetail.propTypes = {};

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

export default connect(mapStateToProps, null)(UserDetail);
